import * as Styled from './RisksControlsGaps.styled';
import * as ReportingStyled from '../Reporting.styled';
import dayjs from 'dayjs';

const formatDate = (date: string | null) => {
  if (!date) return null;
  try {
    return dayjs(date).format('YYYY-MM-DD');
  } catch {
    return date;
  }
};

export const processRiskControlColumns = [
  {
    title: 'Business Process L4 Title',
    dataIndex: 'business_process_l4_title',
    key: 'business_process_l4_title',
    width: 200
  },
  {
    title: 'Process Type',
    dataIndex: 'process_type_name',
    key: 'process_type_name',
    width: 200
  },
  {
    title: 'Process Criticality',
    dataIndex: 'process_criticality_name',
    key: 'process_criticality_name',
    width: 150
  },
  {
    title: 'Group',
    dataIndex: 'group_name',
    key: 'group_name',
    width: 150
  },
  {
    title: 'Division',
    dataIndex: 'division_name',
    key: 'division_name',
    width: 150
  },
  {
    title: 'Region',
    dataIndex: 'region_name',
    key: 'region_name',
    width: 150
  },
  {
    title: 'Legal Entity',
    dataIndex: 'legal_entity_name',
    key: 'legal_entity_name',
    width: 180
  },
  {
    title: 'Business Unit',
    dataIndex: 'business_unit_name',
    key: 'business_unit_name',
    width: 180
  },
  {
    title: 'Risk Title',
    dataIndex: 'risk_title',
    key: 'risk_title',
    width: 200
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    width: 150
  },
  {
    title: 'Root Cause',
    dataIndex: 'root_cause',
    key: 'root_cause',
    width: 180
  },
  {
    title: 'Event',
    dataIndex: 'event',
    key: 'event',
    width: 150
  },
  {
    title: 'Key Risk Indicators',
    dataIndex: 'key_risk_indicators',
    key: 'key_risk_indicators',
    width: 180
  },
  {
    title: 'Risk Owner',
    dataIndex: 'risk_instance_risk_owner',
    key: 'risk_instance_risk_owner',
    width: 150
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Risk validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'risk_validity',
    onHeaderCell: () => ({
      style: Styled.risksControlsHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'risk_instance_start_date',
        key: 'risk_instance_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.risksControlsDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.risksControlsStartDateCellStyle
        }),
        render: formatDate
      },
      {
        title: '',
        dataIndex: 'risk_instance_end_date',
        key: 'risk_instance_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.risksControlsDateHeaderStyle
        }),
        render: formatDate
      }
    ]
  },
  {
    title: 'Assessment Date',
    dataIndex: 'risk_instance_assessment_date',
    key: 'risk_instance_assessment_date',
    width: 120,
    render: formatDate
  },
  {
    title: 'Impact/Consequence',
    dataIndex: 'risk_instance_impact_consequence',
    key: 'risk_instance_impact_consequence',
    width: 180
  },
  {
    title: 'Probability of Occurrence',
    dataIndex: 'risk_instance_probability_of_occurrence_name',
    key: 'risk_instance_probability_of_occurrence_name',
    width: 180
  },
  {
    title: 'Severity',
    dataIndex: 'risk_instance_severity_name',
    key: 'risk_instance_severity_name',
    width: 120
  },
  {
    title: 'Risk Assessment Score',
    dataIndex: 'risk_instance_risk_assessment_score',
    key: 'risk_instance_risk_assessment_score',
    width: 150
  },
  {
    title: 'Speed of Occurrence',
    dataIndex: 'risk_instance_speed_of_occurrence_name',
    key: 'risk_instance_speed_of_occurrence_name',
    width: 150
  },
  {
    title: 'Risk Status',
    dataIndex: 'risk_status_name',
    key: 'risk_status_name',
    width: 120
  },
  {
    title: 'Risk Trend',
    dataIndex: 'risk_trend_name',
    key: 'risk_trend_name',
    width: 120
  },
  {
    title: 'Update Cycle',
    dataIndex: 'risk_instance_update_cycle_name',
    key: 'risk_instance_update_cycle_name',
    width: 120
  },
  {
    title: 'Control Name',
    dataIndex: 'control_name',
    key: 'control_name',
    width: 200
  },
  {
    title: 'Control Description',
    dataIndex: 'control_description',
    key: 'control_description',
    width: 200
  },
  {
    title: 'Control Description 1',
    dataIndex: 'control_description_1',
    key: 'control_description_1',
    width: 200
  },
  {
    title: 'Control Description 2',
    dataIndex: 'control_description_2',
    key: 'control_description_2',
    width: 200
  },
  {
    title: 'Control Objective',
    dataIndex: 'control_objective',
    key: 'control_objective',
    width: 180
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Control validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'control_validity',
    onHeaderCell: () => ({
      style: Styled.risksControlsHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'control_start_date',
        key: 'control_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.risksControlsDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.risksControlsStartDateCellStyle
        }),
        render: formatDate
      },
      {
        title: '',
        dataIndex: 'control_end_date',
        key: 'control_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.risksControlsDateHeaderStyle
        }),
        render: formatDate
      }
    ]
  },
  {
    title: 'Testing Method',
    dataIndex: 'testing_method_name',
    key: 'testing_method_name',
    width: 150
  },
  {
    title: 'Test Type',
    dataIndex: 'test_type_name',
    key: 'test_type_name',
    width: 120
  },
  {
    title: 'Key Control',
    dataIndex: 'key_control',
    key: 'key_control',
    width: 100,
    render: (val: boolean) => (val ? 'Yes' : 'No')
  },
  {
    title: 'Control Type',
    dataIndex: 'control_type',
    key: 'control_type',
    width: 120
  },
  {
    title: 'Control Nature',
    dataIndex: 'control_nature',
    key: 'control_nature',
    width: 120
  },
  {
    title: 'Control Frequency',
    dataIndex: 'control_frequency',
    key: 'control_frequency',
    width: 120
  },
  {
    title: 'Control Owner',
    dataIndex: 'control_instance_owner_name',
    key: 'control_instance_owner_name',
    width: 150
  },
  {
    title: 'Performer TOD',
    dataIndex: 'control_instance_performer_tod_name',
    key: 'control_instance_performer_tod_name',
    width: 150
  },
  {
    title: 'Approver',
    dataIndex: 'control_instance_approver_name',
    key: 'control_instance_approver_name',
    width: 150
  },
  {
    title: 'Performer TOE',
    dataIndex: 'control_instance_performer_toe_name',
    key: 'control_instance_performer_toe_name',
    width: 150
  },
  {
    title: 'Control Performer',
    dataIndex: 'control_instance_control_performer_name',
    key: 'control_instance_control_performer_name',
    width: 150
  },
  {
    title: 'Design Effectiveness',
    dataIndex: 'control_instance_design_effectiveness_name',
    key: 'control_instance_design_effectiveness_name',
    width: 150
  },
  {
    title: 'Operating Effectiveness',
    dataIndex: 'control_instance_operating_effectiveness_name',
    key: 'control_instance_operating_effectiveness_name',
    width: 180
  },
  {
    title: 'Control Status',
    dataIndex: 'control_instance_control_status_name',
    key: 'control_instance_control_status_name',
    width: 120
  },
  {
    title: 'Control Status 2',
    dataIndex: 'control_instance_control_status_2_name',
    key: 'control_instance_control_status_2_name',
    width: 120
  },
  {
    title: 'Reason for Control Status',
    dataIndex: 'control_instance_reason_for_control_status_name',
    key: 'control_instance_reason_for_control_status_name',
    width: 200
  },
  {
    title: 'Test Objectiveness',
    dataIndex: 'control_instance_test_objectiveness_name',
    key: 'control_instance_test_objectiveness_name',
    width: 150
  },
  {
    title: 'Test Objectiveness 2',
    dataIndex: 'control_instance_test_objectiveness_2_name',
    key: 'control_instance_test_objectiveness_2_name',
    width: 150
  },
  {
    title: 'Test Result',
    dataIndex: 'control_instance_test_result_name',
    key: 'control_instance_test_result_name',
    width: 120
  },
  {
    title: 'Evidence Type',
    dataIndex: 'control_instance_evidence_type_name',
    key: 'control_instance_evidence_type_name',
    width: 150
  },
  {
    title: 'Evidence File 1',
    dataIndex: 'evidence_file_1',
    key: 'evidence_file_1',
    width: 150
  },
  {
    title: 'Evidence File 2',
    dataIndex: 'evidence_file_2',
    key: 'evidence_file_2',
    width: 150
  },
  {
    title: 'Last Test Date Design',
    dataIndex: 'last_test_date_design',
    key: 'last_test_date_design',
    width: 150,
    render: formatDate
  },
  {
    title: 'Last Test Date Operational',
    dataIndex: 'last_test_date_operational',
    key: 'last_test_date_operational',
    width: 180,
    render: formatDate
  },
  {
    title: 'Next Test Date',
    dataIndex: 'next_test_date',
    key: 'next_test_date',
    width: 120,
    render: formatDate
  },
  {
    title: 'Test Description',
    dataIndex: 'test_description',
    key: 'test_description',
    width: 200
  },
  {
    title: 'Evidence Description',
    dataIndex: 'evidence_description',
    key: 'evidence_description',
    width: 200
  },
  {
    title: 'Control Instance Description 1',
    dataIndex: 'control_instance_description_1',
    key: 'control_instance_description_1',
    width: 200
  },
  {
    title: 'Control Instance Description 2',
    dataIndex: 'control_instance_description_2',
    key: 'control_instance_description_2',
    width: 200
  },
  {
    title: 'Control Overall Effectiveness',
    dataIndex: 'control_instance_control_overall_effectiveness_name',
    key: 'control_instance_control_overall_effectiveness_name',
    width: 180
  },
  {
    title: 'Comments',
    dataIndex: 'comments',
    key: 'comments',
    width: 150
  }
];
